// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js!../../../node_modules/@material/textfield/dist/mdc.textfield.min.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../../../node_modules/css-loader/dist/cjs.js!../../../node_modules/@material/card/dist/mdc.card.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.material-text-field {
    --mdc-theme-primary: #FFF;
    --mdc-theme-secondary: #FFF;
    background-color: #1976d2;
    padding-left: 15px;
    padding-right: 15px;
    margin-bottom: 5px;
}

.mdc-text-field__input, .mdc-text-field-character-counter, .mdc-text-field-helper-text {
    font-family: 'Nunito Sans', Sans-serif, sans-serif;
}

.material-text-field .mdc-text-field {
    padding-left: 5px;
}

.material-text-field .mdc-text-field--filled {
    background-color: #1976d2;
    height: 51px;
}

.material-text-field .mdc-text-field:not(.mdc-text-field--disabled) .mdc-text-field__input {
    color: #FFF;
}

.mdc-card {
    border-radius: 0;
}

.mdc-line-ripple::before {
    border-bottom-color: #FFF !important;
}

.full-width {
    width: 100%;
}

.material-text-field .mdc-floating-label {
    left: 5px;
    color: white !important;
    padding-left: 0 !important;
}

.material-text-field-v2 {
    --mdc-theme-primary: #1976d2;
    --mdc-theme-secondary: #1976d2;
    margin-bottom: 5px;
}

.material-text-field-v2 .mdc-text-field--filled {
    background-color: transparent;
    height: 51px;
}

.material-text-field-v2 .mdc-line-ripple::before {
    border-bottom-color: #a9a9a8 !important;
}

.material-text-field-v2 .mdc-text-field__input {
    padding-top: 10px;
    margin-top: 15px;
}

/* This is the label shown before the component has the focus */
.material-text-field-v2 .mdc-text-field {
    padding-left: 0;
}

/* 'mdc-floating-label' is the floating label shown when the text field has focus */
.material-text-field-v2 .mdc-floating-label {
    color: #9e9e9e !important;
    left: 0;
}

.sh-text-field-required .material-text-field {
    --mdc-theme-primary: #FFF;
    --mdc-theme-secondary: #FFF;
    --mdc-theme-error: #FF0000;
    background-color: #1976d2;
    padding-left: 15px;
    padding-right: 15px;
    margin-bottom: 5px;
}

.sh-text-field-required .mdc-text-field {
    padding-left: 5px;
}

.sh-text-field-required .material-text-field .mdc-text-field--filled {
    background-color: #1976d2;
}

.sh-text-field-required .material-text-field .mdc-text-field:not(.mdc-text-field--disabled) .mdc-text-field__input {
    color: #FFF;
}

.sh-text-field-required .mdc-card {
    border-radius: 0
}

.sh-text-field-required .mdc-line-ripple::before {
    border-bottom-color: #FFF !important;
}

.sh-text-field-required .mdc-text-field-helper-text {
    color: #FF0000;
    background: white;
    border-radius: 10px;
    padding-right: 10px;
    padding-left: 10px;
    padding-bottom: 5px;
    margin-top: 5px;
}

.sh-text-field-required .mdc-text-field-helper-line {
    padding-left: 5px;
}

.sh-text-field-required .mdc-floating-label {
    left: 5px;
    color: white !important;
    padding-left: 0 !important;
}

.sh-text-field-required .mdc-text-field--filled {
    height: 51px;
}

@media screen and (max-width: 600px) {
    .material-text-field-v2 .mdc-text-field__input {
        font-size: 14px;
    }

    .mdc-text-field-helper-text::before {
        height: auto;
    }

    .sh-text-field-required .mdc-text-field-helper-text {
        padding: 2px 10px;
    }
}


`, "",{"version":3,"sources":["webpack://./src/shared/css/material-text-field.css"],"names":[],"mappings":"AAGA;IACI,yBAAyB;IACzB,2BAA2B;IAC3B,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,kDAAkD;AACtD;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,SAAS;IACT,uBAAuB;IACvB,0BAA0B;AAC9B;;AAEA;IACI,4BAA4B;IAC5B,8BAA8B;IAC9B,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;IAC7B,YAAY;AAChB;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA,+DAA+D;AAC/D;IACI,eAAe;AACnB;;AAEA,mFAAmF;AACnF;IACI,yBAAyB;IACzB,OAAO;AACX;;AAEA;IACI,yBAAyB;IACzB,2BAA2B;IAC3B,0BAA0B;IAC1B,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI;AACJ;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,SAAS;IACT,uBAAuB;IACvB,0BAA0B;AAC9B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI;QACI,eAAe;IACnB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,iBAAiB;IACrB;AACJ","sourcesContent":["@import \"../../../node_modules/@material/textfield/dist/mdc.textfield.min.css\";\n@import \"../../../node_modules/@material/card/dist/mdc.card.css\";\n\n.material-text-field {\n    --mdc-theme-primary: #FFF;\n    --mdc-theme-secondary: #FFF;\n    background-color: #1976d2;\n    padding-left: 15px;\n    padding-right: 15px;\n    margin-bottom: 5px;\n}\n\n.mdc-text-field__input, .mdc-text-field-character-counter, .mdc-text-field-helper-text {\n    font-family: 'Nunito Sans', Sans-serif, sans-serif;\n}\n\n.material-text-field .mdc-text-field {\n    padding-left: 5px;\n}\n\n.material-text-field .mdc-text-field--filled {\n    background-color: #1976d2;\n    height: 51px;\n}\n\n.material-text-field .mdc-text-field:not(.mdc-text-field--disabled) .mdc-text-field__input {\n    color: #FFF;\n}\n\n.mdc-card {\n    border-radius: 0;\n}\n\n.mdc-line-ripple::before {\n    border-bottom-color: #FFF !important;\n}\n\n.full-width {\n    width: 100%;\n}\n\n.material-text-field .mdc-floating-label {\n    left: 5px;\n    color: white !important;\n    padding-left: 0 !important;\n}\n\n.material-text-field-v2 {\n    --mdc-theme-primary: #1976d2;\n    --mdc-theme-secondary: #1976d2;\n    margin-bottom: 5px;\n}\n\n.material-text-field-v2 .mdc-text-field--filled {\n    background-color: transparent;\n    height: 51px;\n}\n\n.material-text-field-v2 .mdc-line-ripple::before {\n    border-bottom-color: #a9a9a8 !important;\n}\n\n.material-text-field-v2 .mdc-text-field__input {\n    padding-top: 10px;\n    margin-top: 15px;\n}\n\n/* This is the label shown before the component has the focus */\n.material-text-field-v2 .mdc-text-field {\n    padding-left: 0;\n}\n\n/* 'mdc-floating-label' is the floating label shown when the text field has focus */\n.material-text-field-v2 .mdc-floating-label {\n    color: #9e9e9e !important;\n    left: 0;\n}\n\n.sh-text-field-required .material-text-field {\n    --mdc-theme-primary: #FFF;\n    --mdc-theme-secondary: #FFF;\n    --mdc-theme-error: #FF0000;\n    background-color: #1976d2;\n    padding-left: 15px;\n    padding-right: 15px;\n    margin-bottom: 5px;\n}\n\n.sh-text-field-required .mdc-text-field {\n    padding-left: 5px;\n}\n\n.sh-text-field-required .material-text-field .mdc-text-field--filled {\n    background-color: #1976d2;\n}\n\n.sh-text-field-required .material-text-field .mdc-text-field:not(.mdc-text-field--disabled) .mdc-text-field__input {\n    color: #FFF;\n}\n\n.sh-text-field-required .mdc-card {\n    border-radius: 0\n}\n\n.sh-text-field-required .mdc-line-ripple::before {\n    border-bottom-color: #FFF !important;\n}\n\n.sh-text-field-required .mdc-text-field-helper-text {\n    color: #FF0000;\n    background: white;\n    border-radius: 10px;\n    padding-right: 10px;\n    padding-left: 10px;\n    padding-bottom: 5px;\n    margin-top: 5px;\n}\n\n.sh-text-field-required .mdc-text-field-helper-line {\n    padding-left: 5px;\n}\n\n.sh-text-field-required .mdc-floating-label {\n    left: 5px;\n    color: white !important;\n    padding-left: 0 !important;\n}\n\n.sh-text-field-required .mdc-text-field--filled {\n    height: 51px;\n}\n\n@media screen and (max-width: 600px) {\n    .material-text-field-v2 .mdc-text-field__input {\n        font-size: 14px;\n    }\n\n    .mdc-text-field-helper-text::before {\n        height: auto;\n    }\n\n    .sh-text-field-required .mdc-text-field-helper-text {\n        padding: 2px 10px;\n    }\n}\n\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
